import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { BarChart, Bar, LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, CartesianGrid } from "recharts";
import { TrendingUp, Users, Ticket } from "lucide-react";

const COLORS = ["#C85A32", "#2B4C3F", "#D4AF37", "#3B6E8F", "#B5527E", "#6B8E23"];
const Card = ({ title, children }) => (
  <div className="rounded-xl border bg-card p-5"><h3 className="font-heading text-2xl mb-4">{title}</h3>{children}</div>
);

export default function Analytics() {
  const [a, setA] = useState(null);
  useEffect(() => { api.get("/admin/analytics").then(({ data }) => setA(data)); }, []);
  if (!a) return <p className="text-muted-foreground">Loading…</p>;

  return (
    <div className="space-y-6">
      <div><h1 className="font-heading text-4xl font-semibold">Lead Analytics</h1><p className="text-muted-foreground">Conversion insights across your funnel.</p></div>

      <div className="grid gap-4 sm:grid-cols-3">
        {[{ icon: Users, l: "Total Leads", v: a.total_leads }, { icon: Ticket, l: "Total Bookings", v: a.total_bookings }, { icon: TrendingUp, l: "Conversion Rate", v: `${a.conversion_rate}%` }].map((s) => (
          <div key={s.l} className="rounded-xl border bg-card p-5 flex items-center justify-between">
            <div><p className="text-sm text-muted-foreground">{s.l}</p><p className="font-heading text-4xl mt-1">{s.v}</p></div>
            <s.icon className="h-8 w-8 text-primary" />
          </div>
        ))}
      </div>

      <div className="grid gap-6 lg:grid-cols-2">
        <Card title="Leads by Source">
          <ResponsiveContainer width="100%" height={260}><PieChart>
            <Pie data={a.leads_by_source} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={90} label>
              {a.leads_by_source.map((e, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}</Pie><Tooltip /></PieChart></ResponsiveContainer>
        </Card>
        <Card title="Leads by City">
          <ResponsiveContainer width="100%" height={260}><BarChart data={a.leads_by_city}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} /><XAxis dataKey="name" tick={{ fontSize: 11 }} /><YAxis allowDecimals={false} /><Tooltip /><Bar dataKey="value" fill="#2B4C3F" radius={[6, 6, 0, 0]} /></BarChart></ResponsiveContainer>
        </Card>
        <Card title="Leads by Trip">
          <ResponsiveContainer width="100%" height={260}><BarChart data={a.leads_by_trip} layout="vertical" margin={{ left: 20 }}>
            <XAxis type="number" hide /><YAxis type="category" dataKey="name" width={130} tick={{ fontSize: 11 }} /><Tooltip /><Bar dataKey="value" fill="#C85A32" radius={[0, 6, 6, 0]} /></BarChart></ResponsiveContainer>
        </Card>
        <Card title="Leads Over Time">
          <ResponsiveContainer width="100%" height={260}><LineChart data={a.leads_by_date}>
            <CartesianGrid strokeDasharray="3 3" /><XAxis dataKey="name" tick={{ fontSize: 10 }} /><YAxis allowDecimals={false} /><Tooltip /><Line type="monotone" dataKey="value" stroke="#D4AF37" strokeWidth={2} /></LineChart></ResponsiveContainer>
        </Card>
        <Card title="Lead Status Breakdown">
          <ResponsiveContainer width="100%" height={260}><BarChart data={a.leads_by_status}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} /><XAxis dataKey="name" tick={{ fontSize: 10 }} /><YAxis allowDecimals={false} /><Tooltip /><Bar dataKey="value" fill="#3B6E8F" radius={[6, 6, 0, 0]} /></BarChart></ResponsiveContainer>
        </Card>
        <Card title="Most Popular Trips (Bookings)">
          <ResponsiveContainer width="100%" height={260}><BarChart data={a.popular_trips} layout="vertical" margin={{ left: 20 }}>
            <XAxis type="number" hide /><YAxis type="category" dataKey="name" width={130} tick={{ fontSize: 11 }} /><Tooltip /><Bar dataKey="value" fill="#B5527E" radius={[0, 6, 6, 0]} /></BarChart></ResponsiveContainer>
        </Card>
      </div>
    </div>
  );
}
